// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")
require("@rails/actiontext")

// import $ from 'jquery';
// global.$ = $;
// global.jQuery - $;


// SELECT2
import "select2/dist/js/select2.full.min";
import "select2/dist/js/i18n/pt-BR";

$(document).ready(function() {
  $(".select2").select2({
    theme: "bootstrap4",
    language: "pt-BR",
    width: '204px'
  });
})


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// INDEX.JS
import '../src/assinatura'
import '../src/main'

// require("src/assinatura/main")

require("trix")

